// src/config/apiBase.js
// URL de base du serveur d'assistance IA local (server/index.js, port 5001).
//
// En développement : `npm run dev` lance le serveur sur http://localhost:5001.
// En production : définir REACT_APP_API_URL dans .env.production
// (ex. https://artkiv.com/api-ia) — la valeur est figée au moment du build CRA.
//
// Toujours importer cette constante plutôt que de coder l'URL en dur :
// c'est l'oubli de cette règle qui avait cassé le suivi conservation IA,
// le générateur de tags et l'OCR de maintenance en production.

export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
